import Vue from 'vue'
import Loader from '@/components/Loader'
import moment from 'moment'
import i18n from '@/languages';

export default {
    components: {
        'loader': Loader
    },

    props: {
        module: {default: ''},
    },

    data() {
        return {
            loader: false,
        }
    },

    computed: {
        hasSideBar() {
            return this.$store.state.structure.access.client_portal
        },
    },

    mounted() {
        let scrollElement = $('.scrollbar-inner', $(this.$el))
        if(process.env.NODE_ENV!=='test') {
            if (scrollElement.length > 0) {
                scrollElement.scrollbar().scrollLock()
            }
        }
    },

    methods: {
        getComponentInstance(component, options) {
            let componentClass = Vue.extend(component)
            componentClass.options.router = this.$router
            componentClass.options.i18n = this.$i18n
            componentClass.options.store = this.$store

            return new componentClass(options)
        },
        getLocaltime(time){
            let momentTime=moment.utc(time).local()
            if(momentTime.diff(new Date(), 'days') === 0)
            {
                return `${i18n.t('LBL_TODAY')} ${momentTime.get('hours')}:${momentTime.get('minutes')}`
            }
            return momentTime.format('DD/MM/YYYY HH:mm')
        },
        getLocalDate(date) {
            let momentTime=moment.utc(date).local()
            return momentTime.format('DD/MM/YYYY')
        },
        scrollToBottom(container) {
            container.scrollTop = container.scrollHeight;
        },

        isMobileScreen() {
            let width = (window.innerWidth > 0) ? window.innerWidth : screen.width
            if(width <= 1199.98){
                return true
            }
            else{
                return false
            }
        },

        detectBrowser() {
            let userAgent = navigator.userAgent;
            let browserName;

            if(userAgent.match(/chrome|chromium|crios/i)){
                browserName = "chrome";
            }else if(userAgent.match(/firefox|fxios/i)){
                browserName = "firefox";
            }  else if(userAgent.match(/safari/i)){
                browserName = "safari";
            }else if(userAgent.match(/opr\//i)){
                browserName = "opera";
            } else if(userAgent.match(/edg/i)){
                browserName = "edge";
            }else{
                browserName = null;
            }

            return browserName;
        },

        isMobileBrowser() {
            const toMatch = [
                /Android/i,
                /webOS/i,
                /iPhone/i,
                /iPad/i,
                /iPod/i,
                /BlackBerry/i,
                /Windows Phone/i
            ];

            return toMatch.some((toMatchItem) => {
                return navigator.userAgent.match(toMatchItem);
            });
        },

        dataURItoBlob(dataURI, type = 'application/pdf') {
            const byteString = window.atob(dataURI);
            const arrayBuffer = new ArrayBuffer(byteString.length);
            const int8Array = new Uint8Array(arrayBuffer);

            for (let i = 0; i < byteString.length; i++) {
                int8Array[i] = byteString.charCodeAt(i);
            }

            return new Blob([int8Array], {type: type});
        },

        transformToModifierClass(str) {
            return str.toLowerCase().split(' ').join('-')
        }
    }
}
